<template>
    <div :class="['google-map', wrapperClass]">
        <div class="iframe-wrapper mb-4" @click="$emit('click')">
            <iframe v-if="latitude && longitude"
                width="100%"
                :height="height"
                style="border: 0"
                loading="lazy"
                allowfullscreen
                :src="`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&center=${latitude + mapCenter},${longitude}`"
              >
              </iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GoogleMapIframe',
    props: {
        apiKey: {
            type: [String, Number],
            default: 'AIzaSyDYDgespYtyMc8ELnoEnw8sWb80xxDNJHg'
        },
        latitude: {
            type: [String, Number],
            default: ''
        },
        longitude: {
            type: [String, Number],
            default: ''
        },
        height: {
            type: [Number],
            default: 500
        },
        wrapperClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            innerWidth: window.innerWidth
        }
    },
    computed: {
         /**
         * @return { Number } Google Map pin position adjustment (latitude)
         * @see {@link https://developers.google.com/maps/documentation/embed/embedding-map? hl=yes}
         */
        mapCenter () {
            return this.innerWidth > 768 ? 0.0006 : this.innerWidth > 440 ? 0.0013 : 0.0009
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    methods: {
        onResize() {
            this.innerWidth = window.innerWidth
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>